import Cookies from "js-cookie"

import { isTestMode } from "helpers/application"

export const FIRST_USER_CLICK_EVENT = "first-user-click"
export const BYPASS_FIRST_CLICK_COOKIE_NAME = "bypass_first_user_click"

// This function is run on every window load. TODO: Verify if this can cause loading issues
export const firstUserClickCheck = () => {
  if (Cookies.get(BYPASS_FIRST_CLICK_COOKIE_NAME)) {
    firstUserClickInit()
  } else {
    window.addEventListener("click", firstUserClickInit)
    window.addEventListener("scroll", firstUserClickInit)
    window.addEventListener("touchstart", firstUserClickInit)
  }
}

export const firstUserClickInit = () => {
  if (!isTestMode) {
    dataLayer.push({
      event: FIRST_USER_CLICK_EVENT,
    })
  }

  if (sl.config.env === "production") {
    loadSignifyd()
  }

  window.removeEventListener("click", firstUserClickInit)
  window.removeEventListener("scroll", firstUserClickInit)
  window.removeEventListener("touchstart", firstUserClickInit)
}

const loadSignifyd = () => {
  if (document.getElementById("sig-api") || !sl.api.signifyd?.js_src) {
    return
  }

  const cartToken = Cookies.get(sl.config.cookies_config.cart_token)
  if (!cartToken) {
    return
  }

  const script = document.createElement("script")
  script.id = "sig-api"
  script.setAttribute("data-order-session-id", cartToken)
  script.src = sl.api.signifyd.js_src
  script.defer = true
  document.head.appendChild(script)
}
